import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '../../firebase';
import { sendPasswordResetEmail } from 'firebase/auth';
import { IconShieldCheck, IconArrowLeft, IconCheck } from '@tabler/icons-react';
import AuthShell from '../../components/auth/AuthShell';
import { slides, PRODUCT_LABEL } from '../../components/auth/slides';

export default function PasswordReset() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleReset = async () => {
    if (!email) {
      setError('Please enter your email address');
      return;
    }
    setLoading(true);
    setError('');
    try {
      await sendPasswordResetEmail(auth, email);
      setSent(true);
    } catch (err) {
      console.error(err);
      switch (err.code) {
        case 'auth/user-not-found':
          setError('No account found with this email address');
          break;
        case 'auth/invalid-email':
          setError('Please enter a valid email address');
          break;
        default:
          setError('Failed to send reset email — please try again');
      }
    }
    setLoading(false);
  };

  return (
    <AuthShell productLabel={PRODUCT_LABEL} slides={slides}>

        <div style={{ fontSize: 22, fontWeight: 400, color: 'var(--color-text-primary)', marginBottom: 6 }}>
          Reset password
        </div>
        <div style={{ fontSize: 13, color: 'var(--color-text-tertiary)', marginBottom: 28 }}>
          We'll send a reset link to your email
        </div>

        <div style={{
          background: 'var(--color-bg-primary)',
          borderRadius: '0 0 var(--radius-xl) var(--radius-xl)',
          border: '0.5px solid var(--color-border-light)',
          borderTop: 'none',
          padding: '28px',
        }}>

          {sent ? (
            <div style={{ textAlign: 'center' }}>
              <div style={{
                width: 52,
                height: 52,
                borderRadius: '50%',
                background: 'var(--color-success-light)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 16px',
              }}>
                <IconCheck size={24} color="var(--color-success)" stroke={1.5} />
              </div>
              <div style={{ fontSize: 16, fontWeight: 400, marginBottom: 8 }}>
                Reset link sent
              </div>
              <div style={{
                fontSize: 13,
                color: 'var(--color-text-tertiary)',
                lineHeight: 1.6,
                marginBottom: 24,
              }}>
                Check your inbox at <strong>{email}</strong> and follow the link to reset your password.
              </div>
              <button
                onClick={() => navigate('/login')}
                style={{
                  width: '100%',
                  background: 'var(--color-brand)',
                  color: '#fff',
                  border: 'none',
                  borderRadius: 'var(--radius-md)',
                  padding: '11px',
                  fontSize: 14,
                  cursor: 'pointer',
                }}
              >
                Back to sign in
              </button>
            </div>
          ) : (
            <>
              {error && (
                <div style={{
                  background: 'var(--color-danger-light)',
                  border: '0.5px solid var(--color-danger)',
                  borderRadius: 'var(--radius-md)',
                  padding: '10px 14px',
                  fontSize: 13,
                  color: 'var(--color-danger)',
                  marginBottom: 16,
                }}>
                  {error}
                </div>
              )}

              <div style={{ marginBottom: 20 }}>
                <label style={{
                  display: 'block',
                  fontSize: 11,
                  color: 'var(--color-text-secondary)',
                  marginBottom: 5,
                }}>
                  Work email
                </label>
                <input
                  type="email"
                  placeholder="you@farm.co.uk"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  onKeyDown={e => e.key === 'Enter' && handleReset()}
                  style={{ width: '100%', boxSizing: 'border-box' }}
                  autoComplete="email"
                />
              </div>

              <button
                onClick={handleReset}
                disabled={loading}
                style={{
                  width: '100%',
                  background: 'var(--color-brand)',
                  color: '#fff',
                  border: 'none',
                  borderRadius: 'var(--radius-md)',
                  padding: '11px',
                  fontSize: 14,
                  cursor: loading ? 'not-allowed' : 'pointer',
                  opacity: loading ? 0.7 : 1,
                  marginBottom: 16,
                }}
              >
                {loading ? 'Sending...' : 'Send reset link'}
              </button>

              <div
                onClick={() => navigate('/login')}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 5,
                  fontSize: 13,
                  color: 'var(--color-text-tertiary)',
                  cursor: 'pointer',
                }}
              >
                <IconArrowLeft size={14} stroke={1.5} /> Back to sign in
              </div>
            </>
          )}
        </div>
    </AuthShell>
  );
}